import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Article } from "../_/components/Article";
import { Ref } from "../_/components/Reference";

export const Mechanics = () => (
    <>
        <Article.Title>
            Rzuty
        </Article.Title>
        <Article.Body>
            <p>Podczas wspólnej rozgrywki gap często będzie rzucał kłody pod nogi postaci, żeby uczynić ich historię jeszcze ciekawszą.
                Do sprawdzenia jak postacie poradzą sobie z takimi wyzwaniami służą rzuty.</p>

            <p>Żeby określić powodzenie przedsięwziętej przez postać gracza czynności testowana będzie jedna z cech.
                Gap określa poziom łatwości testu, gracz natomiast musi uzyskać wynik niższy lub równy na kości cechy.</p>

            <p>W focus im niższy wynik na kości tym lepszy!</p>
        </Article.Body>

        <Article.Title>
            Poziom łatwości
        </Article.Title>
        <Article.Body>
            <p>Wyobraź sobie grupę dziesięciu osób, które próbują trafić rzutką w tarczę. Jeśli tarcza jest bardzo daleko trafi w nią mało osób, jedna może dwie na dziesięć a gdy tarcza jest odpowiednio blisko trafią prawdopodobnie wszyscy, dziesięć na dziesięć.
                To znaczy, że zadania łatwe wykonuje 10 na 10 osób a zadania bardzo trudne tylko 1 na 10 osób. </p>
            <p>Poziom łatwości określa właśnie ile osób na 10 poradziłoby sobie z zadaniem. Łatwość testu określana jest przez gapia(gap może, ale nie musi ujawnić ją graczom).
                Poszczególne poziomy łatwości można interpretować następująco:</p>
            <Table1 />
        </Article.Body>

        <Article.Title anchor="focus">Stany</Article.Title>
        <Article.Body>
            O ile atuty postaci określają ją na stałe, stany określają postać tymczasowo.
            Postać może otrzymać stan np. w wyniku nieudanego rzutu lub działania zdolności.
            Stany mogą być pozytywne np. pokrzepiony, przyśpieszony lub negatywne jak chory czy zmarznięty.
        </Article.Body>

        <Article.Title>
            Skupienie i rozproszenie
        </Article.Title>
        <Article.Body>
            <p>
                Skupienie kości polega na użyciu lepszej kości (czyli niższej) niż wynika to z Twojej cechy, rozproszenie natomiast to użycie gorszej kości. Skupienie przyznaje się jeśli postać posiada <Ref>atut</Ref> , <Ref>stan</Ref> lub <Ref>przedmiot</Ref>,
                które mogą pomóc w testowanej czynności a rozproszenie gdy postać ma <Ref>atut</Ref> lub <Ref>stan</Ref>, które przeszkadzają w zadaniu.
                Możesz użyć maksymalnie dwóch źródeł zapewniających skupienie, jednak nie ma limitu co do źródeł zapewniających rozproszenie. To oznacza, że skupienie może zapewnić kość lepszą o maksymalnie 2 podczas gdy rozproszenie może zredukować kość bez limitu.
                Jeśli jednocześnie występują okoliczności do skupienia jak i do rozproszenia kości niwelują się.
                Gracz kontrolujący postać sam dobiera źródła skupienia i rozproszenia, jednak to gap podejmuje ostateczną decyzję co do ich zastosowania.
            </p>
            <p>
                Czemu gracz ma sam dobierać źródła rozproszenia skoro utrudniają test, dowiesz się w rozdziale <Ref>Upadek</Ref>.
            </p>

            przykłady:
            <ul>
                <li>Postać próbuje wyważyć drzwi, posiada Ciało 3(K8) i atut <strong>Silny</strong>, dlatego może skupić kość i do rzutu użyć kości K6.</li>
                <li>Postać próbuje oczarować rozmówcę, posiada Wpływ 2(K10) i status <strong>Brudny</strong>, dlatego musi rozproszyć kość i finalnie do rzutu użyć K12.</li>
                <li>Postać próbuje przejść po linie ma Ostrość 2(K10) i atuty <strong>Akrobata</strong> oraz <strong>Kocia zwinność</strong> dodatkowo posiada status <strong>Pijany</strong>.
                <strong>Akrobata</strong> i <strong>Kocia</strong> zwinność kwalifikuje postać do skupienia,
                    ale <strong>Pijany</strong> do rozproszenia, dlatego jedno żródło skupienia niweluje się z źródłem rozproszenia i finalnie postać skupia kość o 1 rzucając K8</li>
            </ul>
        </Article.Body>

        <Article.Title>
            Testy sporne
        </Article.Title>
        <Article.Body>
            Obie postacie wykonują test na daną cechę(każda używa swojej kości), postać z niższym wynikiem wygrywa.
            W przypadku remisów spór nie zostaje rozstrzygnięty np. rozgrywka w szachy kończy się remisem,
            lub stronie wywołującej spór nie udaje się zmienić stanu innej postaci
            np. ktoś chce kogoś popchnąć, przy remisie popchnięcie nie dochodzi do skutku.
            Każda z postaci może otrzymać skupienie lub rozproszenie jeśli takowe jej przysługują.
        </Article.Body>

        <Article.Title>
            Pomoc
        </Article.Title>
        <Article.Body>
            Podczas wykonywania testu postać może otrzymać pomoc od swojego sojusznika.
            Pomoc polega na tym, że postać wykonująca test może użyć <Ref>atutu</Ref> pomocnika do <Ref>skupienia</Ref> swojej <Ref>kości cechy</Ref>.
        </Article.Body>

        <Article.Title>
            Testy grupowe
        </Article.Title>
        <Article.Body>
            Test grupowy to test w którym bierze udział kilka postaci. Istnieją dwa typy takiego testu:
        </Article.Body>

        <Article.SubTitle>
            ...im więcej postaci tym łatwiej
        </Article.SubTitle>
        <Article.Body>
            Przykładem może tu być przepychanie wielkiego kamienia lub wspólne przeszukiwaine pomieszczenia.
            W takiej sytuacji wszyscy gracze wykonują test a najlepszy wynik jest wynikiem dla całej drużyny.
            Innymi słowy wystarczy, że jedna postać zda test by cała drużyna odniosła profity z tym związane.
        </Article.Body>

        <Article.SubTitle>
            ...im więcej postaci tym trudniej
        </Article.SubTitle>
        <Article.Body>
            Przykładem takiej sytuacji może być przekradanie się lub blefowanie. Żeby drużyna zdała taki test wszystkie postacie muszą wykonać rzut i zdać test. Postacie, którym test się nie powiódł są słabym ogniwem i mogą pogrążyć całą drużynę chyba, że...
            Inna postać wyrzuciła 1 na kości, każda jedynka pozwala zniwelować jedną porażkę. Ostatecznie postać może też zwiększyć <Ref>Upadek</Ref> by zdać test.
        </Article.Body>

        <Article.Title>
            Poziomy sukcesu i porażki
            </Article.Title>
        <Article.Body>
            O poziomie sukcesu mówimy tylko w przypadku zdanych testów i wynosi on różnicę między stopniem łatwości a wynikiem na kości. Dla przykładu stopień łatwości dla testu to 8, postać wyrzuca na kości cechy 5, 8-5=3 więc stopień sukcesu to 3.
            W przypadku testów niezdanych mówimy o poziomie porażki.
        </Article.Body>
    </>
)

type LevelDice = {
    ease: number,
    description: string
}

const rows1: LevelDice[] = [
    { ease: 10, description: 'Formalność' },
    { ease: 8, description: 'Przeciętne' },
    { ease: 6, description: 'Skomplikowane' },
    { ease: 4, description: 'Trudne' },
    { ease: 2, description: 'Ekstremalnie trudne' },

]
const Table1 = () => (
    <TableContainer component={Paper}>
        <Table  aria-label="simple table">
            <TableHead>
                <TableRow>
                    <TableCell>Łatwość</TableCell>
                    <TableCell>Opis</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {rows1.map((row) => (
                    <TableRow
                        key={row.ease}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell component="th" scope="row">
                            {row.ease}
                        </TableCell>
                        <TableCell component="th" scope="row">
                            {row.description}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
)